// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modals .more-menu-overlay .modal-more-menu[data-v-8abeb5fa]{right:9.8%!important}", ""]);
// Exports
module.exports = exports;
